interface QuantityStepperProps {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  size?: "sm" | "md";
}

export default function QuantityStepper({
  value,
  onChange,
  min = 1,
  max = 99,
  size = "md",
}: QuantityStepperProps) {
  const dim = size === "sm" ? "h-9 w-9" : "h-11 w-11";
  const text = size === "sm" ? "text-sm" : "text-base";

  const decrease = () => onChange(Math.max(min, value - 1));
  const increase = () => onChange(Math.min(max, value + 1));

  return (
    <div className="inline-flex items-center rounded-md border border-background-300 bg-background-50">
      <button
        type="button"
        onClick={decrease}
        disabled={value <= min}
        aria-label="Diminuir quantidade"
        className={`flex ${dim} cursor-pointer items-center justify-center rounded-l-md text-foreground-700 transition-colors hover:bg-background-100 disabled:cursor-not-allowed disabled:opacity-40`}
      >
        <i className="ri-subtract-line text-lg" />
      </button>
      <span className={`min-w-[2.5rem] text-center ${text} font-medium text-foreground-900`}>
        {value}
      </span>
      <button
        type="button"
        onClick={increase}
        disabled={value >= max}
        aria-label="Aumentar quantidade"
        className={`flex ${dim} cursor-pointer items-center justify-center rounded-r-md text-foreground-700 transition-colors hover:bg-background-100 disabled:cursor-not-allowed disabled:opacity-40`}
      >
        <i className="ri-add-line text-lg" />
      </button>
    </div>
  );
}